<template>
  <div v-if="!(typeof item.hidden == 'function' && item.hidden())">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          :class="{ 'submenu-title-noDropdown': !isNest }"
          :index="resolvePath(onlyOneChild.path)"
        >
          <template v-if="isCollapse">
            <i
              v-if="onlyOneChild.meta.icon"
              class="customIcon lpIconfont"
              :class="onlyOneChild.meta.icon"
            ></i>
            <i v-else></i>
            <span class="title" slot="title">{{
              onlyOneChild.meta.title
            }}</span>
          </template>
          <div v-else class="icon_wrapper">
            <i
              v-if="onlyOneChild.meta.icon"
              class="customIcon lpIconfont"
              :class="onlyOneChild.meta.icon"
            ></i>
            <i v-else></i>
            <span class="title" slot="title">{{
              onlyOneChild.meta.title
            }}</span>
          </div>
        </el-menu-item>
      </app-link>
    </template>
    <!--下拉-->
    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <!-- <i :class="item.meta.icon" /> -->
        <i
          v-if="item.meta.icon"
          class="customIcon lpIconfont"
          :class="item.meta.icon"
        ></i>
        <i v-else></i>
        <span>{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :base-path="resolvePath(child.path)"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";

export default {
  name: "SidebarItem",
  components: { AppLink },
  mixins: [FixiOSBug],
  props: {
    // 路由对象
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      onlyOneChild: null,
    };
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          this.onlyOneChild = item;
          return true;
        }
      });

      if (showingChildren.length === 1) {
        return true;
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
  },
};
</script>

<style scoped>
i {
  margin-left: 10px;
}
</style>

<style lang="scss" scope>
.icon_wrapper {
  display: flex;
  align-items: baseline;
}
.customIcon {
  margin-right: 8px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  // vertical-align: middle !important;
  display: inline-block;
}
</style>
